import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { Component } from "react";

import Home from "./Pages/Home";
import MeetTheTeam from "./Pages/AboutUs/MeetTheTeam";
import TheCompany from "./Pages/AboutUs/TheCompany";
//import PropertiesList from "./Properties/PropertiesList";
import Lettings from "./Properties/Lettings";
import Sales from "./Properties/Sales";
import ProcessRent from "./Pages/ProcessRent";
import Register from "./Forms/Register";
import ProcessSales from "./Pages/ProcessSales";
import Testimonials from "./Testimonials/Testimonials";
import Faqs from "./Accordions/Faqs";
import Contact from "./Forms/Contact";
import PropertyDetails from "./Properties/PropertyDetails";
import SearchResults from "./Components/SearchBar/SearchResults";
import Additional from "./Pages/Additional";
import BookValuation from "./Forms/BookValuation";
import PrivacyPolicy from "./Pages/Footer/PrivacyPolicy";
import TandC from "./Pages/Footer/TandC";
import CookieBanner from "./Components/CookieBanner";
import CookiePolicy from "./Pages/Footer/CookiePolicy";
import ScrollButton from "./Components/Navigation/ScrollButton";

export class App extends Component {
  render() {
    return (
      <div className="App">
      <BrowserRouter>
      <Routes>
        {/* Top Navigation */}
        <Route index element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/meet-the-team" element={<MeetTheTeam />} />
        <Route path="about-the-company" element={<TheCompany />} />
        <Route path="/lettings" element={<Lettings />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/process-with-lettings" element={<ProcessRent />} />
        <Route path="/process-with-sales" element={<ProcessSales />} />
        <Route path="/register-with-us" element={<Register />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/additional-services" element={<Additional />} />
        <Route path="/book-valuation" element={<BookValuation />} />

        
        {/* Footer Navigation */}
        <Route path="/faqs" element={<Faqs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TandC />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />

        {/* Property Details Route */}
        <Route path="/property-details/:property_ref" element={<PropertyDetails />} />
      

        {/* Search Results */}

        <Route path="/search-results" element={<SearchResults />} />

        

      </Routes>
      </BrowserRouter>  
      <CookieBanner />
      <ScrollButton />
      </div>
    );
  }
}

export default App;